var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9602 19.6625C2.7802 19.6625 0.200195 16.8982 0.200195 13.4911C0.200195 10.7997 1.8082 8.5111 4.0482 7.66681C4.0442 7.5511 4.0402 7.43538 4.0402 7.31967C4.0402 3.5311 6.9042 0.462524 10.4402 0.462524C12.8122 0.462524 14.8802 1.84252 15.9882 3.89967C16.5962 3.46252 17.3322 3.20538 18.1202 3.20538C20.2402 3.20538 21.9602 5.04824 21.9602 7.31967C21.9602 7.84252 21.8682 8.33967 21.7042 8.80252C24.0402 9.30824 25.8002 11.524 25.8002 14.1768C25.8002 17.2068 23.5082 19.6625 20.6802 19.6625H5.9602ZM9.1202 10.3625C8.74419 10.7654 8.74419 11.4168 9.1202 11.8154C9.49619 12.214 10.1042 12.2182 10.4762 11.8154L12.0362 10.144L12.0402 15.8911C12.0402 16.4611 12.4682 16.9197 13.0002 16.9197C13.5322 16.9197 13.9602 16.4611 13.9602 15.8911V10.144L15.5202 11.8154C15.8962 12.2182 16.5042 12.2182 16.8762 11.8154C17.2482 11.4125 17.2522 10.7611 16.8762 10.3625L13.6762 6.93395C13.3002 6.5311 12.6922 6.5311 12.3202 6.93395L9.1202 10.3625Z",
    fill: "#BBB0A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconGray);
export default __webpack_public_path__ + "static/media/upload-icon-gray.6b12c01b55c2f669597a1a5d33249246.svg";
export { ForwardRef as ReactComponent };